import { useState, useEffect } from 'react';
import { usewpdataSelectors } from '../../lib/wpdataState/selectors';
import s from './floater.module.scss';
import CtaButton from '../ProductHero/CtaButton/CtaButton';
import parse from 'html-react-parser';
import './floating-bar.scss';
import StockCountdown from '../ProductHero/StockCountdown/StockCountdown';

const FloatingCTA = () => {
  const { Floater, Theme, Settings } = usewpdataSelectors();
  const [timerLabel, setTimerLabel] = useState(Floater?.timerLabel ?? '');
  const initialTime = 30 * 60;
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show the floating CTA after a short delay or when user scrolls
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);

    // Optional: Hide/show based on scroll position
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const pageHeight = document.body.scrollHeight;
      const windowHeight = window.innerHeight;

      // Show when user has scrolled down a bit (adjust threshold as needed)
      if (scrollPosition > 300) {
        setIsVisible(true);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 0) {
          clearInterval(intervalId);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const minutes = Math.floor((timeLeft % 3600) / 60)
      .toString()
      .padStart(2, 0);
    const seconds = (timeLeft % 60).toString().padStart(2, 0);
    const adjustedTime = Floater?.timerLabel?.replace('###react_time###', ` ${minutes}:${seconds} `) ?? '';
    setTimerLabel(adjustedTime);
  }, [timeLeft]);

  return (
    <section
      id="floating-cta"
      style={{ background: Floater.styles.background }}
      className={`floating-cta ${isVisible ? 'floating-cta--active' : ''}`}
    >
      <div className="floating-cta__wrapper">
        <div className="floating-cta__content">
          {Floater.floaterImage && (
            <img
              className="floating-cta__contentImage mon-img-64-w"
              src={Floater.floaterImage}
              alt={Settings.brandName}
            />
          )}

          <div className="floating-cta__contentRating">
            <img
              src={`${window.template_root}/stars/${Floater.starsImage}.svg`}
              className="floater__image--stars coarse"
              alt={Settings.brandName}
            />
            <span className="floating-cta__verbalScore" style={{ color: Floater.styles.textColorSecondary }}>
              {parse(Floater?.verbalScore)}
            </span>
          </div>
          <div
            className={`floating-cta__contentText mobile-none`}
            style={{ color: Floater.styles.textColorPrimary }}
            data-theme={Theme.heading}
          >
            {Floater.floaterHeading}
          </div>
        </div>
        <div className="floating-cta__ctaWrapper">
          <CtaButton />
          <StockCountdown
            lowStockText={timerLabel}
            textColor={Floater?.styles?.textColorPrimary}
            className={s.floaterStock}
          />
        </div>
      </div>
    </section>
  );
};

export default FloatingCTA;
